module.exports = __webpack_public_path__ + "static/media/logo-animation.5142e2e6.gif";